import type { QueryClient } from '@tanstack/react-query'

import { pendingSignupFirstNameQueryOptions } from '../queries/auth-flow-queries'
import { queryKeys } from '../queries/query-keys'
import {
  clearPendingSignupState,
  setPendingSignupFirstName,
} from './auth-flow-storage'

export async function beginSignupFlow({ firstName }: { firstName: string }) {
  await setPendingSignupFirstName(firstName)
}

export async function completeSignupBootstrap({
  authUserId,
  queryClient,
}: {
  authUserId: string | null
  queryClient: Pick<QueryClient, 'setQueryData' | 'removeQueries'>
}) {
  await clearPendingSignupState()
  queryClient.setQueryData(pendingSignupFirstNameQueryOptions().queryKey, null)
  queryClient.removeQueries({
    queryKey: queryKeys.authFlow.createUserAttempt(authUserId),
    exact: true,
  })
}
